import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable, switchMap } from "rxjs";
import { Store } from "@ngrx/store";
import { State } from "../reducers";
import { CookieService } from "../services/cookie.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private cookieService: CookieService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const jwt = this.cookieService.getCookie("jwt");
    const clonedRequest = req.clone({
      headers: jwt
        ? req.headers.set("Authorization", `Bearer ${jwt}`).delete("Cookie")
        : req.headers.delete("Cookie"),
    });
    return next.handle(clonedRequest);
  }
}
